


















































import { VBTooltip } from 'bootstrap-vue';

export default {
  name: 'AttributeTitle',
  directives: {
    BTooltip: VBTooltip,
  },
  props: {
    attribute: {
      type: Object,
      required: true,
    },
  },
};
